import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";

import { useDebouncedMutation } from "../../../../common/Utils/useDebouncedMutation";
import { SetStatusFN } from "./SetStatusFN";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
const key = "set_title";
export function useTodoEditSetTitle(
  id: string,
  remoteTitle: string,
  setStatus: SetStatusFN
) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const [updateTitle, loading] = useMutation(graphql`
    mutation useTodoEditSetTitleMutation(
      $id: ID!
      $title: String!
      $employeeId: ID
    ) {
      todo(todoId: $id, employeeId: $employeeId) {
        updateTitle(newTitle: $title) {
          id
          title
          ...TodoEditTimeline_todo @defer
        }
      }
    }
  `);

  const saveTitle = useCallback(
    (title: string) =>
      updateTitle({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          title,
          employeeId: currentEmployeeId,
        },
      }),
    [id, setStatus, updateTitle, currentEmployeeId]
  );

  return [
    ...useDebouncedMutation(remoteTitle, saveTitle, 500, undefined, () =>
      setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
